import styled, { css } from 'styled-components';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Wrapper = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: 1fr 521px;
  grid-gap: 25px;
  padding: 30px;
`;

export const Holder = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-rows: 1fr;
  grid-gap: 30px;
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${(props) => (props.height ? props.height : '100%')};
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  padding: 25px;
`;

export const ImageHolder = styled.div`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: ${(props) => props.theme.background};
`;

export const Arrow = styled.span`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  color: ${(props) => props.theme.color};
  text-shadow: 0px 3px 6px ${(props) => props.theme.shadow};
  cursor: pointer;
  z-index: +2;

  ${(props) =>
    props.left &&
    css`
      left: 0;
    `}

  ${(props) =>
    props.right &&
    css`
      right: 0;
    `}
`;

export const ArrowIcon = styled.i`
  color inherit;
  font-size: 72px;
`;

export const Image = styled.img`
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: +1;
`;

export const Video = styled.video`
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: +1;
`;

export const Placeholder = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 128px;
`;

export const ImageMenu = styled.div`
  position: absolute;
  z-index: +1;

  ${(props) =>
    props.top &&
    css`
      top: 15px;
    `}

  ${(props) =>
    props.bottom &&
    css`
      bottom: 15px;
    `}

  ${(props) =>
    props.right &&
    css`
      right: 20px;
    `}

  ${(props) =>
    props.left &&
    css`
      left: 20px;
    `}
`;

export const ContentHolder = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
  padding: 4px 0 12px;
  border-bottom: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
`;

export const Title = styled.h2`
  display: inline-flex;
  align-items: center;
  color: ${(props) => props.theme.color};
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  cursor: default;
`;

export const Content = styled.div`
  display: block;
  width: 100%;
  padding: 15px 0;
`;

export const Details = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: auto;
  margin: -5px -5px 15px;
`;

export const Detail = styled.span`
  display: inline-block;
  width: auto;
  margin: 5px;
  padding: 8px 11px;
  border-radius: 5px;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
  font-size: 17px;
  font-weight: 700;
  line-height: 1;
  text-align: left;
  cursor: default;
`;

export const DetailLabel = styled.span`
  display: inline;
  width: auto;
  color: ${(props) => props.theme.color};
`;

export const Button = styled.button`
  ${commonButton}
  min-width: 137px;
`;

export const ButtonIcon = styled.i`
  margin-left: -5px;
  margin-right: 5px;
`;

export const ActionButton = styled.button`
  ${commonButton}
  margin-left: 15px;
`;

export const ActionButtonIcon = styled.i``;

export const Switcher = styled.div`
  display: flex;
  width: auto;
`;

export const SwitcherButton = styled.button`
  ${commonButton}
  min-width: 156px;

  &:first-of-type {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  &:last-of-type {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`;

export const Category = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 25px;
`;

export const CategoryTitle = styled.h3`
  display: block;
  width: 100%;
  margin-bottom: 15px;
  color: ${(props) => props.theme.color};
  font-size: 18px;
  font-weight: 500;
  cursor: default;
`;

export const CategoryValues = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 8px;
`;

export const CategoryValue = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 7px;
  border-radius: 10px;
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.background};
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  word-break: break-word;
  cursor: pointer;

  ${(props) =>
    props.selected &&
    css`
      color: ${(props) => props.theme.colorOnSelected};
      background: ${(props) => props.theme.backgroundOnSelected};
    `}
`;

export const Selectbox = styled.div`
  display: block;
  width: 100%;
  padding-right: 25px;
`;
